/* eslint-disable max-len */
/* eslint-disable max-lines */
if (!window.cloudI18n) {
  window.cloudI18n = {};
}
window.cloudI18n.fr = {
  ' as part of my care journey.': ' dans le cadre de mon parcours de soins.',
  ' more characters to meet the recommended minimum': ' caract\u00e8res de plus pour atteindre le minimum recommand\u00e9',
  ', and I consent to the ': ', et je consens \u00e0 la ',
  ', the ': ', la ',
  '1 year old': '1 an',
  'A default appointment reason has been generated but you can still change it. It will be displayed in the participants calendars, in their notifications and in the video call.': 'Un motif de rendez-vous par d\u00e9faut a \u00e9t\u00e9 g\u00e9n\u00e9r\u00e9 mais vous pouvez toujours le changer. Il sera affich\u00e9 dans les agendas des participants, dans leurs notifications et dans l\u2019appel vid\u00e9o.',
  'A link to the payment page will also be sent': 'Un lien vers la page de paiement sera aussi envoy\u00e9',
  'A user whose calendar is selected does not have a profile that allows delegated access. Please contact a user manager.': 'L\u2019utilisateur dont l\u2019agenda est s\u00e9lectionn\u00e9 ne dispose pas d\u2019un profil autorisant l\u2019acc\u00e8s en d\u00e9l\u00e9gation. Veuillez contacter un administrateur.',
  'A valid email address is required for appointments with payment.': 'Une adresse email valide est requise pour les rendez-vous avec paiement.',
  Accept: 'Accepter',
  Accepted: 'Accept\u00e9',
  'Access code': 'Code d\u2019acc\u00e8s',
  Actions: 'Actions',
  Activate: 'Activer',
  'Activate payment': 'Activer le paiement',
  'Active principle': 'Principe actif',
  Acts: 'Actes',
  'Acts section': 'Actes',
  Add: 'Ajouter',
  'Add ': 'Ajoutez ',
  'Add a rate': 'Ajouter un tarif',
  'Add all character types (uppercase, lowercase, numbers, special characters)': 'Ajoutez tous les types de caract\u00e8res (majuscules, minuscules, chiffres, sp\u00e9ciaux)',
  'Add email address': 'Ajouter l\u2019adresse email',
  Address: 'Adresse',
  'Administration route': "Mode d'administration",
  Age: '\u00c2ge',
  'Air SMUR Teams': '\u00c9quipe SMUR vecteur a\u00e9rien',
  'Al (VNI)': 'Al (VNI)',
  'All your appointment settings are displayed. Click on any of them in order to change it.': 'Tous vos param\u00e8tres de rendez-vous sont affich\u00e9s. Cliquez sur l\u2019un d\u2019entre eux si vous a besoin de le changer.',
  'Already have an account?': 'Vous avez d\u00e9j\u00e0 un compte ?',
  'Ambient air': 'Air ambiant',
  Amount: 'Montant',
  'An account already exists': 'Un compte existe d\u00e9j\u00e0',
  'An appointment is already set for this time slot.': 'Un rendez-vous est d\u00e9j\u00e0 positionn\u00e9 sur ce cr\u00e9neau horaire.',
  'An appointment is in progress': 'Un rendez-vous est en cours',
  'An error occured while fetching options. Please try again later.': "Une erreur s'est produite lors de la r\u00e9cup\u00e9ration des options. Veuillez r\u00e9essayer ult\u00e9rieurement.",
  'An error occurred while fetching fees. Please try again later.': "Une erreur s'est produite lors de la r\u00e9cup\u00e9ration des tarifs. Veuillez r\u00e9essayer ult\u00e9rieurement.",
  'An error occurred while fetching recordings. Please contact Parsys support.': "Une erreur s'est produite lors de la r\u00e9cup\u00e9ration des enregistrements.Veuillez contacter le support Parsys.",
  'An error occurred while processing your request.': 'Une erreur s\u2019est produite lors du traitement de votre demande.',
  'An error occurred. Please retry later.': 'Une erreur est survenue. Veuillez r\u00e9essayer dans quelques instants.',
  Anonymous: 'Anonyme',
  'Anonymous patient': 'Patient anonyme',
  'Anything left to do?': 'Reste-il quelque chose \u00e0 faire ?',
  Appointment: 'Rendez-vous',
  'Appointment created.': 'Rendez-vous cr\u00e9\u00e9.',
  'Appointment duration as set by the practitioner': 'Dur\u00e9e du rendez-vous pr\u00e9d\u00e9finie par le praticien',
  'Appointment duration predefined by the practitioner': 'Dur\u00e9e du rendez-vous pr\u00e9d\u00e9finie par le praticien',
  'Appointment durations': 'Dur\u00e9es de rendez-vous personalis\u00e9es',
  'Appointment filters': 'Filtres de rendez-vous',
  'Appointment types': 'Types de rendez-vous',
  Appt: 'Rdv',
  'Are you sure you want to change the appointment form? The fields will be reset.': '\u00cates-vous s\u00fbr de vouloir modifier le formulaire de prise de rendez-vous ? Les champs seront r\u00e9initialis\u00e9s.',
  'Are you sure you want to delete this medicine?': '\u00cates-vous s\u00fbr de vouloir supprimer ce m\u00e9dicament ?',
  'Are you sure you want to delete this rate? This action cannot be undone.': '\u00cates-vous s\u00fbr(e) de vouloir supprimer ce tarif ? Cette action est irr\u00e9versible.',
  Attachments: 'Pi\u00e8ces jointes',
  Attributed: 'Affect\u00e9e',
  'Availabilities could not be created on the following dates because they overlap with existing ones': 'Les disponibilit\u00e9s n\u2019ont pas pu \u00eatre cr\u00e9es aux dates suivantes car elles chevauchent des disponibilit\u00e9s existantes.',
  'Availabilities created.': 'Disponibilit\u00e9s cr\u00e9\u00e9es.',
  Availability: 'Disponibilit\u00e9s',
  'Availability cannot be changed or moved there because it would overlap with another one.': 'La disponibilit\u00e9 ne peut \u00eatre \u00e9tendue ou d\u00e9plac\u00e9e ici parce qu\u2019elle entre en conflit avec une autre disponibilit\u00e9.',
  Available: 'Disponible',
  'Awaiting capture': 'En attente de pr\u00e9l\u00e8vement',
  'Awaiting payment': 'En attente de paiement',
  BMI: 'IMC',
  Back: 'Retour',
  Bandwidth: 'Bande passante',
  'Be more specific to narrow down the search': 'Soyez plus sp\u00e9cifique pour affiner la recherche',
  'Bill later': 'Facturer plus tard',
  'Bill now': 'Facturer maintenant',
  Billing: 'Facturation',
  Birthdate: 'Date de naissance',
  'Blood pressure': 'Pression art\u00e9rielle',
  'Blood sugar': 'Glyc\u00e9mie',
  Bold: 'Gras',
  'Book an appointment': 'Prendre un rendez-vous',
  'Booth Teleconsultation': 'T\u00e9l\u00e9consultation en cabine',
  'Booth teleconsultation': 'T\u00e9l\u00e9consultation en cabine',
  'Born on': 'N\u00e9(e) le',
  'Browse other weeks': 'Parcourir autres semaines',
  'Browser not supported.': 'Navigateur non support\u00e9.',
  'CV (VI)': 'VC (VI)',
  'Calendar controls': 'Contr\u00f4les du calendrier',
  'Calendar of': 'Calendrier de',
  'Call Information': "Information sur l'appel",
  'Caller identity': "Identit\u00e9 de l'appelant",
  Cancel: 'Annuler',
  'Cancel appointment': 'Annuler le rendez-vous',
  Cancelled: 'Annul\u00e9',
  'Change Appointment Form': 'Changer de formulaire',
  'Change history': 'Historique des modifications',
  'Charge a fee': 'Facturer',
  'Check my Equipment': 'V\u00e9rifier mon \u00c9quipement',
  'Check that you can manage the practitioner\u2019s calendar': 'V\u00e9rifier que vous avez les droits pour g\u00e9rer l\u2019agenda du praticien',
  'Choose a fee': 'Facturer',
  'Choose teleconsultation mode': 'Choisir le mode de t\u00e9l\u00e9consultation',
  Classification: 'Classification',
  'Click a practitioner\u2019s name to edit their calendar.': 'Cliquez sur un nom de praticien pour modifier son agenda.',
  'Click on a mobile resource name to modify its calendar.': 'Cliquez sur un nom de ressource mobile pour modifier son agenda.',
  'Click on the "desired slot" field and chose the date and time at which you want the appointment to be set.': 'Cliquez sur le "cr\u00e9neau d\u00e9sir\u00e9" et choisissez la date et l\u2019heure \u00e0 laquelle vous voulez placer le rendez-vous.',
  'Clinical Examination': 'Examen clinique',
  'Clinical interpretation of the ECG report may be affected by the filter settings.': "L'interpr\u00e9tation clinique de l'ECG pourrait \u00eatre affect\u00e9e par les param\u00e8tres de filtre.",
  Close: 'Fermer',
  Closed: 'Clos',
  'Color code': 'Code couleur',
  Columns: 'Colonnes',
  'Commercial name': 'Nom commercial',
  Conditioning: 'Mise en condition',
  Confirm: 'Confirmer',
  'Confirm appointment': 'Confirmer le rendez-vous',
  'Confirm cancellation': 'Confirmez l\u2019annulation',
  'Confirm password': 'Confirmer le mot de passe',
  'Confirm the creation': 'Confirmer la cr\u00e9ation',
  Confirmed: 'Confirm\u00e9',
  'Consultation fee predefined by the practitioner': 'Frais de consultation pr\u00e9d\u00e9finis par le praticien',
  Consultations: 'Consultations',
  'Contact phone number': 'T\u00e9l\u00e9phone du contact',
  Context: 'Contexte',
  Copied: 'Copi\u00e9',
  'Copy patient link': 'Copier lien du patient',
  'Copy practitioner link': 'Copier lien du praticien',
  'Corresponds to a functional or technical test. Do not use for medical diagnosis.': 'Correspond \u00e0 un test fonctionnel ou technique. Ne pas utiliser pour un diagnostic m\u00e9dical.',
  Country: 'Pays',
  Create: 'Cr\u00e9er',
  'Create a new location': 'Cr\u00e9er un nouveau lieu',
  'Create a patient': 'Cr\u00e9er un patient',
  'Create a patient if they do not already exist': 'Cr\u00e9er un patient s\u2019il n\u2019existe pas d\u00e9j\u00e0',
  'Create my patient account': 'Cr\u00e9er mon compte patient',
  'Create the appointment': 'Cr\u00e9er le rendez-vous',
  Creation: 'Cr\u00e9ation',
  'Custom appointment duration': 'Dur\u00e9e du rendez-vous personnalis\u00e9e',
  Cutaneous: 'Cutan\u00e9',
  DIA: 'DIA',
  Date: 'Date',
  Day: 'Journ\u00e9e',
  Decline: 'Refuser',
  Default: 'Tarif par d\u00e9faut',
  Delete: 'Supprimer',
  'Delete rate': 'Supprimer un tarif',
  Description: 'Description',
  'Desired slot': 'Cr\u00e9neau d\u00e9sir\u00e9',
  'Display details': 'Afficher les d\u00e9tails',
  'Document added': 'Document ajout\u00e9',
  Download: 'T\u00e9l\u00e9charger',
  'Draft saved locally.': 'Brouillon enregistr\u00e9 localement.',
  'Drug added': 'M\u00e9dicament ajout\u00e9',
  'Drug deleted': 'M\u00e9dicament supprim\u00e9',
  Duration: 'Dur\u00e9e',
  ECG: 'ECG',
  EVA: 'EVA',
  Edit: 'Modifier',
  'Edit email address': 'Modifier l\u2019adresse email',
  'Edit location': 'Modifier le lieu',
  'Edit rate': 'Modifier le tarif',
  'Edit the appointment reason': 'Modifier le motif de rendez-vous',
  'Edit the practitioner\u2019s calendar': 'Modifier l\u2019agenda du praticien',
  'Edit the resource\u2019s calendar': "Modifier l'agenda de la resource",
  'Email addresses': 'Adresses email',
  End: 'Fin',
  'End date': 'Date de fin',
  'End of recurrence': 'Fin de la r\u00e9currence',
  'End time': 'Heure de fin',
  'Enter a practitioner\u2019s name (minimum 3 characters)': 'Entrez un nom de praticien (3 caract\u00e8res minimum)',
  'Enter at least 3 characters to begin searching': 'Entrez au moins 3 carat\u00e8res pour commencer la recherche',
  'Enter the patient\u2019s name (minimum 3 characters)': 'Entrez le nom du patient (3 lettres minimum)',
  'Enter the practitioner\u2019s name (minimum 3 characters)': 'Entrez le nom du praticien (3 lettres minimum)',
  Erase: 'Effacer',
  'Error adding drug. Please try again.': "Erreur lors de l'ajout du m\u00e9dicament. Veuillez r\u00e9essayer.",
  'Error adding rate. Please try again.': "Erreur lors de l'ajout du tarif. Veuillez r\u00e9essayer.",
  'Error deleting drug. Please try again.': 'Erreur lors de la suppression du m\u00e9dicament. Veuillez r\u00e9essayer.',
  'Error deleting rate. Please try again.': 'Erreur lors de la suppression du tarif. Veuillez r\u00e9essayer.',
  'Error editing drug. Please try again.': 'Erreur lors de la modification du m\u00e9dicament. Veuillez r\u00e9essayer.',
  'Error editing rate. Please try again.': 'Erreur lors de la modification du tarif. Veuillez r\u00e9essayer.',
  EtCO2: '',
  'EtCO2 (VI)': 'EtCO2 (VI)',
  Exams: 'Examens',
  Excellent: 'Excellent',
  Expired: 'Expir\u00e9',
  'Extend chat window': '\u00c9tendre la fen\u00eatre du chat',
  'Facility List': "Liste d'\u00e9tablissements",
  Fair: 'Moyen',
  'FiO2 (O2)': 'FiO2 (O2)',
  'FiO2 (VI)': 'FiO2 (VI)',
  'FiO2 (VNI)': 'FiO2 (VNI)',
  Filter: 'Filtrer',
  'Filter by location': 'Filtrer par lieu',
  Filters: 'Filtres',
  'Filters applied': 'Filtres appliqu\u00e9s',
  'Find a consultation location': 'Trouver un lieu de consultation',
  'Find an expert': 'Trouver un expert',
  Finish: 'Terminer',
  'First call date': 'Date du premier appel',
  'First name': 'Pr\u00e9nom',
  'Flight No': 'N\u00b0 vol',
  'Flow (O2)': 'D\u00e9bit (O2)',
  'Flow rate': 'D\u00e9bit',
  'For readability\u2019s sake, only up to 5 simultaneously.': 'Pour des raisons de lisibilit\u00e9, seulement jusqu\u2019\u00e0 5 simultan\u00e9ment.',
  Fullscreen: 'Plein \u00e9cran',
  'Functional or technical test': 'Test fonctionnel ou technique',
  Gender: 'Sexe',
  Glasgow: 'Glasgow',
  Glucose: 'Glucose',
  Good: 'Bon',
  'Ground SMUR Teams': '\u00c9quipe SMUR au sol',
  'Heading large': 'Titre grand',
  'Heading medium': 'Titre moyen',
  'Heading small': 'Titre petit',
  'Heart rate': 'Fr\u00e9quence cardiaque',
  Help: 'Aide',
  'Hide details': 'Masquer les d\u00e9tails',
  History: 'Historique',
  'How can I add a practitioner\u2019s calendar to the multiple view?': 'Comment puis-je ajouter l\u2019agenda d\u2019un praticien \u00e0 la vue multiple ?',
  'How many calendar can I view at the same time?': 'Combien d\u2019agenda puis-je voir en m\u00eame temps ?',
  'How to activate payment?': 'Comment activer le paiement ?',
  'How to find a slot?': 'Comment trouver un cr\u00e9neau ?',
  'How to find practitioners?': 'Comment trouver des praticiens ?',
  'How to find the patient?': 'Comment trouver un patient ?',
  'How to find the practitioner?': 'Comment trouver un praticien ?',
  'How to find the requesting practitioner?': 'Commment trouver le praticien requ\u00e9rant ?',
  'How to specify a slot?': 'Comment sp\u00e9cifier un cr\u00e9neau ?',
  Hémocue: 'H\u00e9mocue',
  'I accept the ': "J'accepte les ",
  ID: 'ID',
  'IP (VI)': 'PI (VI)',
  IVD: 'IVD',
  IVL: 'IVL',
  IVSE: 'IVSE',
  'If no location is available for appointments, it is necessary to add availability to the mobile resource calendar.': "Si aucun lieu n'est disponible pour la prise de rendez-vous, il est necessaire d'ajouter des disponibilit\u00e9s dans l'agenda des ressources mobiles.",
  'If the "Next" button is not disabled, it means that some slots may be available in the upcoming weeks.': 'Si le bouton "Suivant" n\u2019est pas d\u00e9sactiv\u00e9, cela signifie que certains cr\u00e9neaux sont disponibles dans les prochaines semaines.',
  'If the patient has never been registered, you need to open the creation form by clicking on the "Create a patient" button and fill it up. Then you will be able to finish the last steps of the appointment form.': 'Si le patient n\u2019a jamais \u00e9t\u00e9 enregistr\u00e9, il faut ouvrir le formulaire de cr\u00e9ation en cliquant sur le bouton "Cr\u00e9er un patient" et le renseigner. Vous pourrez alors finir de remplir les derni\u00e8res \u00e9tapes du formulaire de prise de rendez-vous.',
  'If the practitioner has set up billing, the payment is then automatically activated with the amount they have predefined. However, you can deactivate the payment if the patient is reimbursed 100%, and modify the amount if necessary.': 'Si le praticien a configur\u00e9 la facturation, le paiement sera automatiquement activ\u00e9 lors de la prise de rendez-vous. Vous devrez alors s\u00e9lectionner un montant parmi ceux d\u00e9finis par le praticien. Vous pouvez d\u00e9sactiver le paiement si le patient est pris en charge \u00e0 100 % (ex. ALD, C2S, AME). ',
  'If they do not have disabled them, invited practitioners will receive notifications upon appointment creation, cancellation, or some time before its starts, as a reminder.': 'S\u2019ils ne les ont pas d\u00e9sactiv\u00e9s, les praticiens invit\u00e9s vont recevoir des notifications lors de la cr\u00e9ation d\u2019un rendez-vous, son \u00e9ventuelle annulation, ou sous la forme d\u2019un rappel avant qu\u2019il commence.',
  'In order for the search to give results, you need to supply at least three consecutive characters contained in the patient\u2019s name.': 'Pour que la recherche renvoie des r\u00e9sultats, vous devez fournir au moins trois caract\u00e8res cons\u00e9cutifs contenus dans le nom du patient.',
  'In order for the search to give results, you need to supply at least three consecutive characters contained in the practitioner\u2019s name.': 'Pour que la recherche renvoie des r\u00e9sultats, vous devez fournir au moins trois caract\u00e8res cons\u00e9cutifs contenus dans le nom du praticien.',
  'In order to book an appointment, you need to select a user that delegated their calendar management to you in their profile settings. They will be set as the requester practitioner from whom the appointment originated.': 'Pour r\u00e9server un rendez-vous, s\u00e9lectionnez un utilisateur qui a d\u00e9l\u00e9gu\u00e9 la gestion de son agenda \u00e0 vous dans ses param\u00e8tre utilisateur. Il sera assign\u00e9 comme praticien requ\u00e9rant pour ce rendez-vous.',
  Inhalation: 'Inhalation',
  'Initial CCC': 'Premier CCC',
  Intervention: 'Intervention',
  'Intervention List': 'Liste des interventions',
  'Intervention Number': "Num\u00e9ro d'intervention",
  Interventions: 'Interventions',
  Interview: 'Interview',
  Intramuscular: 'Intramusculaire',
  Intranasal: 'Intranasal',
  Intrarectal: 'Intrarectal',
  'Invalid configuration': 'Configuration invalide',
  'Invalid email address': 'Adresse e-mail invalide',
  'Invalid phone number': 'Num\u00e9ro de t\u00e9l\u00e9phone invalide',
  Italic: 'Italique',
  'Join as patient': 'Rejoindre en tant que patient',
  'Join as practitioner': 'Rejoindre en tant que praticien',
  LTC: 'ALD',
  Label: 'Intitul\u00e9',
  'Last CCC': 'Dernier CCC',
  'Last Message': 'Dernier Message',
  'Last event': 'Dernier \u00e9v\u00e9nement',
  'Last known lat/lng ': 'Derni\u00e8re position connue',
  'Last name': 'Nom',
  'Last updated ': 'Derni\u00e8re mise \u00e0 jour',
  'Last updated on': 'Derni\u00e8re mise \u00e0 jour',
  'Let the notifications be sent': 'Laisser les notifications s\u2019envoyer',
  Loading: 'Chargement',
  'Loading...': 'Chargement...',
  Location: 'Lieu',
  'Location selection': 'S\u00e9lection du lieu',
  Logout: 'D\u00e9connexion',
  MAP: 'PAM',
  'Make sure a practitioner is available': 'S\u2019assurer qu\u2019un praticien est disponible',
  'Make sure some practitioners are available': 'Assurez vous que des praticiens sont disponibles',
  'Make sure that the practitioner delegated their calendar management to you in their profile settings.': 'Assurez-vous que le praticien vous a d\u00e9l\u00e9gu\u00e9 la gestion de son agenda dans ses param\u00e8tres utilisateur.',
  'Map Legend': 'L\u00e9gende',
  Medcapture: 'Medcapture',
  'Medical consultation between the patient, possibly assisted by a health professional, and a practitioner.': 'Consultation m\u00e9dicale entre le patient \u00e9ventuellement assist\u00e9 d\u2019un professionnel de sant\u00e9 et un praticien.',
  'Medical developments': '\u00c9volution m\u00e9dicale',
  'Mobil units': 'Unit\u00e9 Mobiles',
  'Modify the patient contact information': 'Changer les informations de contact du patient',
  Month: 'Mois',
  'Multiple view': 'Vue multiple',
  'My calendar': 'Mon agenda',
  NIBP: 'PNI',
  Name: 'Nom',
  'New Appointment': 'Nouveau rendez-vous',
  'New data is available': 'De nouvelles donn\u00e9es sont disponibles',
  'Next appointment': 'Prochain rendez-vous',
  'Next slot on': 'Prochain cr\u00e9neau le',
  No: 'Non',
  'No available facilities': 'Aucun \u00e9tablissement disponible',
  'No available slots.': 'Aucun cr\u00e9neau disponible.',
  'No expert is available for this slot or this type of appointment.': 'Aucun expert n\u2019est disponible pour ce cr\u00e9neau ou ce type de rendez-vous.',
  'No expert matches your search.': 'Aucun expert trouv\u00e9 pour votre recherche',
  'No filter applied': 'Aucun filtre appliqu\u00e9',
  'No intervention in progress': 'Aucune intervention en cours',
  'No location is available for scheduling appointments.': "Aucun lieu n'est disponible pour la prise de rendez-vous",
  'No locations are available': "Aucun lieu n'est disponible",
  'No locations available?': "Aucun lieu n'est disponible ?",
  'No match found.': 'Aucune correspondance trouv\u00e9e.',
  'No options available': 'Aucune autre option disponible',
  'No other expert is available for this slot or this type of appointment.': 'Aucun autre expert n\u2019est disponible pour ce cr\u00e9neau ou ce type de rendez-vous.',
  'No password': 'Aucun mot de passe',
  'No past appointment.': 'Pas de rendez-vous pass\u00e9s',
  'No patient matches your search.': 'Aucun patient trouv\u00e9 pour votre recherche',
  'No practitioner has delegated their calendar to you.': 'Aucun praticien ne vous a d\u00e9l\u00e9gu\u00e9 la gestion de leur agenda.',
  'No recordings found for the selected date range. Try a wider search.': "Aucun enregistrement trouv\u00e9 pour la plage de dates s\u00e9lectionn\u00e9e. Essayer d'\u00e9largir la recherche.",
  'No slot available this week.': 'Aucun cr\u00e9neau disponible cette semaine.',
  'No slots available.': 'Aucun cr\u00e9neau disponible',
  'No teleconsultation modes available.': 'Aucun mode de t\u00e9l\u00e9consultation disponible.',
  'No therapeutics found': 'Aucun m\u00e9dicament trouv\u00e9',
  'No upcoming appointment.': 'Aucun rendez-vous \u00e0 venir.',
  'No workflows available': 'Pas de workflow disponible',
  'Non-telemedicine appointments (in-person consultation, home visit, etc.)': 'Rendez-vous physique (consultation en pr\u00e9sentiel, visite \u00e0 domiciel, etc.)',
  Normal: 'Normal',
  'Not Attributed': 'Non affect\u00e9e',
  'Not authorized': 'Non autoris\u00e9',
  Notes: 'Notes',
  'Notify external participants': 'Notifier des participants externes',
  'Notify the patient': 'Notifier le patient',
  OL: 'Liste numerot\u00e9e',
  Ok: 'Ok',
  'Once you are satisfied with all the options you set, create the appointment by clicking the "Finish" button. Invited practitioners that did not delegate their calendar to you will have to approve the appointment.': 'Une fois que vous \u00eates satisfait des options choisies, cr\u00e9ez le rendez-vous en cliquant sur le bouton "Terminer". Les praticiens invit\u00e9s qui ne vous ont pas d\u00e9l\u00e9gu\u00e9 la gestion de leur agenda vont devoir accepter la demande de rendez-vous.',
  'Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching patients and find the one you are looking for.': 'La recherche ne montre que 15 r\u00e9sultats maximum en m\u00eame temps. Entrez plus de caract\u00e8res pour r\u00e9duire le nombre de r\u00e9sultats et trouver le patient que vous recherchez.',
  'Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching practitioners and find the one you are looking for.': 'La recherche ne montre que 15 r\u00e9sultats maximum en m\u00eame temps. Entrez plus de caract\u00e8res pour r\u00e9duire le nombre de r\u00e9sultats et trouver le praticien que vous recherchez.',
  'Only a maximum of 15 results are shown at a time. Type more characters to reduce the number of matching practitioners and find the ones you are looking for.': 'La recherche ne montre que 15 r\u00e9sultats maximum en m\u00eame temps. Entrez plus de caract\u00e8res pour r\u00e9duire le nombre de r\u00e9sultats et trouver les praticiens que vous recherchez.',
  'Only the practitioners who are available for the appointment type you have chosen are listed here. If they delegated their calendar to you, you are able to edit their availabilities.': 'Seuls les praticiens qui sont disponibles pour le type de rendez-vous que vous avezchoisi sont list\u00e9s ici. S\u2019ils vous ont d\u00e9l\u00e9gu\u00e9 la gestion de leur agenda, vous pourrez modifier leurs disponibilit\u00e9s.',
  'Only the practitioners who have some availabilities for the appointment type you have specified are listed here. If they delegated their calendar to you, you are able to edit their availabilities.': 'Seuls les praticiens qui ont des disponibilit\u00e9s pour le type de rendez-vous que vous avez sp\u00e9cifi\u00e9 sont list\u00e9s ici. S\u2019ils vous ont d\u00e9l\u00e9gu\u00e9 la gestion de leur agenda, vous pourrez modifier leurs disponibilit\u00e9s.',
  'Open in new tab': 'Ouvrir dans un nouvel onglet',
  Origin: 'Origine',
  'Other (in-person, etc.)': 'Autre (en personne, etc.)',
  'Other (tele-expertise, face-to-face, ...)': 'Autre (t\u00e9l\u00e9-expertise, face \u00e0 face, ...)',
  'Other surveillance data': 'Autres donn\u00e9es de surveillance',
  Oximetry: 'Oxym\u00e9trie',
  PDF: 'PDF',
  'PEEP (VI)': 'PEEP (VI)',
  'PEEP (VNI)': 'PEEP (VNI)',
  PR: 'FC',
  'Pacemaker detected. The automatic measurements displayed may be less accurate.': 'Pacemaker detect\u00e9. Les mesures automatiques affich\u00e9es peuvent \u00eatre moins pr\u00e9cises.',
  'Parsys ID': '',
  Password: 'Mot de passe',
  'Password meets requirements': 'Mot de passe conforme aux exigences',
  'Password too short': 'Mot de passe trop court',
  'Passwords do not match': 'Le mot de passe ne correspond pas',
  Past: 'Pass\u00e9',
  Patient: 'Patient',
  'Patient created.': 'Patient cr\u00e9\u00e9.',
  'Patient record': 'Dossier patient',
  'Patient updated.': 'Patient modifi\u00e9.',
  'Patient was not modified, please try again.': 'Le patient n\u2019a pas \u00e9t\u00e9 modifi\u00e9, veuillez r\u00e9essayer.',
  'Pay later': 'Facturer plus tard',
  Payment: 'Paiement',
  'Payment failed.': 'Paiement \u00e9chou\u00e9',
  'Payment selection': 'Selection de paiement',
  'Pending appointment': 'Rendez-vous en attente',
  'Per Os': 'Per os',
  'Personal reminder': 'Rappel personnel',
  'Phone number': 'T\u00e9l\u00e9phone',
  Photo: 'Photo',
  'Pick a date and time': 'Choisir une date et une heure',
  Planning: 'Planning',
  'Please contact your administrator or download a compatible browser.': 'Veuillez contacter votre administrateur ou t\u00e9l\u00e9charger un navigateur compatible',
  'Please enter a valid email address.': 'Saisissez une adresse email valide.',
  'Please select the location where the meeting will take place.': 'Veuillez s\u00e9lectionner le lieu o\u00f9 aura lieu la r\u00e9union',
  Practitioners: 'Experts',
  Prescription: 'Prescription',
  'Press "Enter" to validate email addresses.': 'Appuyez sur "Entr\u00e9e" pour valider les adresses email.',
  'Primary Specialty': 'Sp\u00e9cialit\u00e9 principale',
  'Privacy Policy': 'Politique de confidentialit\u00e9',
  'Professional-to-professional act, patient not present.': "R\u00e9union entre professionnels, en l'absence du patient",
  Project: 'Projet',
  Proposed: 'Propos\u00e9',
  Pulse: 'Pouls',
  'Quantity per volume': 'Quantit\u00e9 ou volume',
  RF: 'FR',
  'RF (VI)': 'FR (VI)',
  'Reason (Required)': 'Raison (Obligatoire)',
  'Receiving Facility': "\u00c9tablissement d'accueil",
  Recourse: 'Recours',
  Recurrence: 'R\u00e9currence',
  Redo: 'Refaire',
  'Reduce chat window': 'R\u00e9duire la fen\u00eatre du chat',
  Reminder: 'Rappel',
  'Requester expert': 'Expert requ\u00e9rant',
  'Required expert': 'Expert requis',
  'Reset current center and zoom': 'Recentrer la carte',
  'Respiratory rate': 'Fr\u00e9quence respiratoire',
  'Room ID': 'ID de la salle',
  Route: 'Itin\u00e9raire',
  'SAMU SMUR': 'SAMU SMUR',
  SMUR: 'SMUR',
  SYS: 'SYS',
  SaO2: 'SaO2',
  'Sampling rate': '\u00c9chantillonage',
  Save: 'Enregistrer',
  Scale: '\u00c9chelle',
  Score: 'Score',
  Scores: 'Scores',
  'Sea SMUR Teams': '\u00c9quipe SMUR vecteur maritime',
  Search: 'Rechercher',
  'Search for a therapeutic to add it': "Rechercher un m\u00e9dicament pour l'ajouter",
  'Search...': 'Rechercher...',
  'Searching...': 'Recherche en cours...',
  'Seat No/Staff No': 'N\u00b0 de si\u00e8ge/N\u00b0 du personnel',
  'Select a location': 'S\u00e9lectionner un lieu',
  'Select a patient': 'S\u00e9lectionnez un patient',
  'Select a practitioner': 'S\u00e9lectionnez un praticien',
  'Select a slot': 'S\u00e9lectionnez un cr\u00e9neau',
  'Select an appointment type': 'S\u00e9lectionner un type de rendez-vous',
  'Select practitioners': 'S\u00e9lectionner les praticiens',
  'Select/Deselect all': 'S\u00e9lectionner/D\u00e9s\u00e9lectionner tout',
  'Select/Unselect all': 'S\u00e9lectionner/D\u00e9s\u00e9lectionner tout',
  Send: 'Envoyer',
  'Serial Number': 'Num\u00e9ro de s\u00e9rie',
  'Set as default': 'D\u00e9finir comme tarif par d\u00e9faut',
  'Set the appointment duration': 'Choisir la dur\u00e9e du rendez-vous',
  'Severe Trauma': 'Traumatisme s\u00e9v\u00e8re',
  'Shared notes': 'Notes partag\u00e9es',
  'Show more slots': 'Afficher plus de cr\u00e9neaux',
  'Sign in': 'Se connecter',
  Site: 'Site',
  Solute: 'Solut\u00e9',
  'Some practitioners might only be available for other time slots or appointment types.': 'Certains praticiens pourraient n\u2019\u00eatre disponibles que sur d\u2019autres cr\u00e9neaux ou pour d\u2019autres types de rendez-vous.',
  SpCO: 'SpCO',
  SpO2: 'SpO2',
  Spirometry: 'Spirom\u00e9trie',
  Start: 'D\u00e9but',
  'Start date': 'Date de d\u00e9but',
  'Start time': 'Heure de d\u00e9but',
  Station: 'Station',
  Status: 'Statut',
  Submit: 'Valider',
  Summary: 'R\u00e9sum\u00e9',
  Support: 'Support',
  Surveillance: 'Surveillance',
  'Synchronization in progress...': 'Synchronisation en cours...',
  'Teams and facilities': '\u00c9quipes et \u00e9tablissements',
  'Tele-expertise / Tele-staff / Multidisciplinary team meeting': 'T\u00e9l\u00e9expertise / T\u00e9l\u00e9staff / R\u00e9union de concertation pluridisciplinaire (RCP)',
  Teleconsultation: 'T\u00e9l\u00e9consultation',
  Telestaff: 'T\u00e9l\u00e9staff',
  Temperature: 'Temp\u00e9rature',
  Tenant: 'Tenant',
  Tenants: 'Tenants',
  'Terms and Conditions': 'Obligations L\u00e9gales',
  'Terms of Service': "Conditions d'utilisation",
  Test: 'Test',
  'Thank you for your payment!': 'Merci pour votre paiement !',
  'That user will be added to the list of visible calendars and the first one you have ticked (in a chronological order) will be hidden from the multiple view.': 'Cet utilisateur sera ajout\u00e9 \u00e0 la liste des agendas visible and le premier que vous avez coch\u00e9 (dans l\u2019ordre chronologique) ne sera plus visible sur la vue multiple.',
  'The cancellation of an appointment is final. Are you sure you want to cancel this appointment?': 'Cette annulation est d\u00e9finitive. \u00cates-vous s\u00fbr de vouloir annuler ce rendez-vous\u00a0?',
  'The duration displayed in blue is the one defined by the practitioner. However, you can change this duration by selecting from the drop-down menu of the "Appointment duration" field. The selected duration will be used to find the slots in the practitioner\u2019s calendar.': 'La dur\u00e9e affich\u00e9e en bleue est celle qui est d\u00e9finie par le praticien. Vous pouvez red\u00e9finir cette dur\u00e9e malgr\u00e9 tout en la s\u00e9lectionnant sur le menu d\u00e9roulant du champ "Dur\u00e9e du rendez-vous". La dur\u00e9e s\u00e9lectionn\u00e9e sera utilis\u00e9e pour trouver des cr\u00e9aneaux horaires dans l\u2019agenda du praticien.',
  'The endowment list is empty. Add therapies to fill the list.': 'La liste de dotation est vide. Ajoutez des th\u00e9rapeutiques pour remplir la liste.',
  'The following leads include a saturated signal: ': 'Les d\u00e9rivations suivantes contiennent une saturation du signal :',
  'The patient already exists.': 'Le patient existe d\u00e9j\u00e0.',
  'The patient videoconference link was successfully copied to your clipboard.': 'Le lien de visioconf\u00e9rence du patient a \u00e9t\u00e9 copi\u00e9 dans votre presse-papiers.',
  'The practitioner videoconference link was successfully copied to your clipboard.': 'Le lien de visioconf\u00e9rence du pratitien a \u00e9t\u00e9 copi\u00e9 dans votre presse-papiers.',
  "The practitioner's RPPS number must be set on both Parsys and Premiocare systems to make an appointment.": 'Le num\u00e9ro RRPS doit \u00eatre configur\u00e9 \u00e0 la fois chez Parsys et Premiocare pour prendre un RDV.',
  'The slot that you choose will be the date and time at which the appointment will be set in the participants calendars.': 'Le cr\u00e9neau que vous choisissez sera la date et l\u2019heure \u00e0 laquelle le rendez-vous figurera dans les agenda des autres participants.',
  'The type of appointment defines the kind of participants that you will be able to invite and how the data gathered during the appointment will be processed.': 'Le type de rendez-vous d\u00e9finit quels participants vous allez pouvoir inviter et comment les donn\u00e9es rassembl\u00e9es pendant le rendez-vous seront trait\u00e9es.',
  'Therapeutics section': 'Th\u00e9rapeutiques',
  'There are no resource to display.': "Il n'y a pas de resource \u00e0 afficher.",
  'There was an error while updating your settings. Please try again later or contact your administrator.': 'Une erreur s\u2019est produite lors de la mise \u00e0 jour de vos param\u00e8tres. Veuillez r\u00e9essayer ult\u00e9rieurement ou contacter votre administrateur.',
  'This availability has been shared on other environments to which you do not have access. Please contact Parsys support.': 'Cette disponibilit\u00e9 a \u00e9t\u00e9 partag\u00e9e sur d\u2019autres environnements auxquels vous n\u2019avez pas acc\u00e8s. Veuillez contacter le support Parsys.',
  'This consultation can no longer be paid. It may have been cancelled.': 'Cette consultation ne peut plus \u00eatre pay\u00e9e. Elle a peut-\u00eatre \u00e9t\u00e9 annul\u00e9e.',
  'This consultation has already been paid.': 'Cette consultation a d\u00e9j\u00e0 \u00e9t\u00e9 pay\u00e9e.',
  'This enumerates all the practitioners who have delegated their calendar management to you.': 'Ceci liste tous les praticiens qui vous ont d\u00e9l\u00e9gu\u00e9 la gestion de leur agenda.',
  'This is the only available appointment type for the selected practitioner': 'Ceci est le seul type de rendez-vous disponible pour le praticien s\u00e9lectionn\u00e9',
  'This patient is missing mandatory fields for Premiocare appointments:': 'Il manque \u00e0 ce patient des champs obligatoires pour les rendez-vous Premiocare:',
  'This practitioner is not available for any type of appointment.': 'Ce praticien n\u2019est disponible pour aucun type de rendez-vous.',
  "This practitioner's RPPS number is not set in Parsys.": "Le num\u00e9ro RPPS de ce praticien n'est pas d\u00e9fini chez Parsys.",
  'This teleconsultation mode is required for the selected practitioner': 'Ce mode de t\u00e9l\u00e9consultation est requis pour le praticien s\u00e9lectionn\u00e9',
  Today: 'Aujourd\u2019hui',
  Transdermal: 'Transdermique',
  'Try another time slot or appointment type': 'Essayez un autre cr\u00e9neau ou un autre type de rendez-vous',
  Type: 'Type',
  'Type at least 3 characters to start your search.': 'Tapez au moins 3 caract\u00e8res pour d\u00e9marrer votre recherche.',
  'Type at least three letters to search': 'Saisissez au moins trois lettres pour effectuer la recherche',
  'Type of residence': 'Type de r\u00e9sidence',
  UL: 'Liste \u00e0 puces',
  Unavailable: 'Indisponible',
  Underline: 'Soulign\u00e9',
  Undo: 'Annuler',
  Unread: 'Non-lu',
  Upcoming: '\u00c0 venir',
  'Upload failed': 'Echec du t\u00e9l\u00e9chargement',
  Urgency: 'Urgence',
  'Use ctrl+mouse wheel to zoom.': 'Utilisez ctrl+la molette de la souris pour zoomer.',
  User: 'Utilisateur',
  'User Profile': 'Profil Utilisateur',
  'User settings': 'Param\u00e8tres de l\u2019utilisateur',
  Validate: 'Valider',
  Validated: 'Valid\u00e9',
  'Very weak': 'Tr\u00e8s faible',
  Video: 'Vid\u00e9o',
  'Video consultation': 'T\u00e9l\u00e9consultation',
  Videoconference: 'Visioconf\u00e9rence',
  'Videoconference room': 'Salle de visioconf\u00e9rence',
  'View the agenda of several practitioners': 'Voir l\u2019agenda de plusieurs praticiens',
  'Vitals section': 'Constantes',
  'Warning: your browser seems to be outdated. Please consider updating to a more recent browser.': 'Avertissement: votre navigateur semble \u00eatre obsol\u00e8te. Merci de le mettre \u00e0 jour.',
  Weak: 'Faible',
  Week: 'Semaine',
  'Weekly recurrence': 'R\u00e9currence hebdomadaire',
  'What happens if I select a 6th practitioner?': 'Que se passe-t-il si je s\u00e9lectionne un 6e praticien ?',
  'When moving your mouse over a practitioner\u2019s avatar or initials, you can tick a checkbox to add their events to the multiple view. Un-tick it to hide them.': 'Lorsque vous d\u00e9placez votre curseur sur l\u2019avantar ou les initiales d\u2019un praticien, vous pouvez cocher une case pour ajouter leur \u00e9v\u00e8nements sur la vue multiple. D\u00e9cochez cette case pour les cacher.',
  'Which type should you choose?': 'Quel type de rendez-vous choisir ?',
  'Who are the listed users?': 'Qui sont les utilisateurs list\u00e9s ?',
  Yes: 'Oui',
  'You are able to book an appointment for any user that delegated their calendar management to you in their profile settings.': 'Vous pouvez r\u00e9server un rendez-vous pour n\u2019importe quel utilisateur qui vous a d\u00e9l\u00e9gu\u00e9 la gestion de son agenda dans ses param\u00e8tres utilisateur.',
  'You are able to invite any user to the appointment. Those who did not delegate their calendar management to you in their profile settings will have to approve the appointments.': 'Vous pouvez inviter n\u2019importe quel utilisateur \u00e0 un rendez-vous. Ceux qui ne vous ont pas d\u00e9l\u00e9gu\u00e9 la gestion de leur agenda dans leurs param\u00e8tres utilisateur vont devoir confirmer la demande de rendez-vous.',
  'You are able to select any available user for the appointment. If they did not delegate their calendar management to you in their profile settings, they will have to approve the appointment.': 'Vous pouvez s\u00e9lectionner n\u2019importe quel utilisateur disponible pour le rendez-vous. S\u2019il ne vous a pas d\u00e9l\u00e9gu\u00e9 la gestion de son agenda dans ses param\u00e8tres utilisateur, il devra confirmer la demande de rendez-vous.',
  'You can check and edit the patient contact information so that they can receive (or not) a notification and a reminder for the appointment you are setting. To do so, just click the "Edit email address" button.': 'Vous pouvez v\u00e9rifier et modifier les informations de contact du patient afin qu\u2019il puisse recevoir (ou non) une notification et un rappel pour le rendez-vous que vous \u00eates en train de mettre en place. Pour ce faire, cliquez sur "Modifier l\u2019adresse mail".',
  'You can choose the slot you want in order to find a practitioner that is available at that time.': 'Vous pouvez choisir le cr\u00e9neau que vous voulez pour trouver un praticien qui est disponible \u00e0 ce moment-l\u00e0.',
  'You can only display 5 agendas at a time. Please deselect one.': 'Vous ne pouvez afficher que 5 agendas \u00e0 la fois. Veuillez en d\u00e9s\u00e9lectionner un.',
  'You can select another practitioner in the list on the left panel': 'Vous pouvez s\u00e9lectionner un autre praticien dans la liste figurant sur le panneau de gauche',
  'You can set the duration you want by selecting it in the dropdown menu of the "appointment duration" field. It will be used to find slots in the practitioner\u2019s schedule. Then click "Confirm".': 'Vous pouvez choisir la dur\u00e9e que vous souhaitez en la s\u00e9lectionnant sur le menu d\u00e9roulant du champ "Dur\u00e9e de rendez-vous". Elle sera utilis\u00e9e pour trouver les cr\u00e9neaux dans l\u2019agenda du praticien. Ensuite cliquez sur "Confirmer".',
  'You can\u2019t delete or modify an availability when an active appointment is booked on it. Please edit your appointments before modifying the availability.': 'Vous ne pouvez pas supprimer ou modifier une plage de disponibilit\u00e9 si un rendez-vous y est programm\u00e9. Veuillez modifier vos rendez-vous avant de modifier cette disponibilit\u00e9.',
  'You must accept the terms to continue': 'Vous devez accepter les conditions pour continuer',
  'You will be redirected to Stripe in a few seconds...': 'Vous serez redirig\u00e9 vers Stripe dans quelques secondes...',
  'Your account has been created successfully. Please check your email to verify your address and complete your account setup.': 'Votre compte a bien \u00e9t\u00e9 cr\u00e9\u00e9. Veuillez consulter votre boite mail pour v\u00e9rifier votre adresse et finaliser la configuration de votre compte.',
  'Your actions during the procedure will appear here.': "Vos actes durant l'intervention apparaitront ici.",
  'Your browser (or its version) isn\u2019t compatible with the telemedecine solution.': 'Votre navigateur (ou sa version) n\u2019est pas compatible avec la solution de t\u00e9l\u00e9m\u00e9decine.',
  'Your rates': 'Vos tarifs',
  'Your search doesn\u2019t match any practitioner.': 'Aucun praticien pour vos crit\u00e8res de recherche.',
  'Your settings have been updated.': 'Vos param\u00e8tres ont \u00e9t\u00e9 mis \u00e0 jour.',
  at: '\u00e0',
  calculating: 'calcul',
  d: 'jour(s)',
  day: 'jour(s)',
  'day and': 'jour et',
  'days and': 'jours et',
  done: 'termin\u00e9',
  draft: 'brouillon',
  hour: 'heure',
  in: 'dans',
  link: 'lien',
  m: 'mois',
  measures: 'mesures',
  min: 'min',
  minutes: 'minutes',
  'modified By': 'Modifi\u00e9 par',
  month: 'mois',
  or: 'ou',
  overdue: 'en retard',
  'practice of telemedicine': 'pratique de la t\u00e9l\u00e9m\u00e9decine',
  saved: 'enregistr\u00e9',
  'uploads in progress': 'envois en cours',
  week: 'semaine(s)',
  'will not receive an invitation nor a reminder by email.': 'ne recevra ni invitation ni rappel par e-mail.',
  'will receive an invitation and a reminder by email.': 'recevra une invitation et un rappel par e-mail.',
  y: 'an(s)',
  year: 'an(s)',
  'years old': 'ans',
};
